<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="activeNotification"
      :key="mainText"
      class="notification flex"
      :class="notificationClasses"
    >
      <div class="notification__content flex--column">
        <span v-if="isErrorNotification" class="notification__error-title">
          {{ $t('common.errorLabel') }}
        </span>

        <div class="flex--space-between--center">
          <p
            v-if="hasMainText"
            class="notification__main-text u-typography-helvetica u-text u-text--s"
            :class="mainTextClasses"
          >
            {{ mainText }}
          </p>
          <button
            v-if="isAddToCartNotification"
            class="notification__open-cart-button u-typography-gilroy u-text u-text--s"
            @click="onOpenCart"
          >
            {{ $t('checkout.openCart') }}
          </button>
        </div>

        <i
          v-if="hasAdditionalText"
          class="notification__additional-text u-typography-helvetica u-text u-text--xs"
        >
          {{ $t(additionalText) }}
        </i>
        <slot name="additional-content"></slot>
      </div>
      <button
        v-if="hasCloseButton"
        class="notification__close-button button--transparent"
        @click="onClose"
      >
        <span class="close-button__icon icon">{{ $options.closeIcon }}</span>
      </button>
    </div>
  </transition>
</template>

<script>
import { ICON_VALUE, ICON } from '@/constants/icons';

export default {
  name: 'AppNotification',
  closeIcon: ICON_VALUE[ICON.CLOSE],
  props: {
    activeNotification: {
      type: Boolean,
      default: false
    },
    mainText: {
      type: String,
      default: ''
    },
    additionalText: {
      type: String,
      default: ''
    },
    hasCloseButton: {
      type: Boolean,
      default: false
    },
    isErrorNotification: {
      type: Boolean,
      default: false
    },
    isAddToCartNotification: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasMainText() {
      return this.mainText !== '';
    },
    hasAdditionalText() {
      return this.additionalText !== '';
    },
    notificationClasses() {
      return {
        'notification--add-to-cart-type': this.isAddToCartNotification,
        'notification--error-type': this.isErrorNotification
      };
    },
    mainTextClasses() {
      return {
        'notification__main-text--with-bottom-margin': this.hasAdditionalText,
        'notification__main-text--error': this.isErrorNotification
      };
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onOpenCart() {
      this.$emit('open-cart');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/icon.scss';
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/buttons.scss';

.notification {
  min-height: 45px;
  padding: 18px 24px;

  box-shadow: 25px 25px 50px rgba(193, 182, 173, 0.3);
  border-radius: 8px;

  z-index: 11;

  &--add-to-cart-type {
    background-color: var(--u-color-light-green);
  }

  &--error-type {
    background-color: var(--u-color-red-50);
  }

  &__content {
    width: 100%;
    justify-content: center;
    margin-right: 10px;
  }

  &__error-title {
    margin-bottom: 5px;
    font-size: 1.3rem;
    line-height: 2rem;
    font-weight: 500;
    text-align: center;
    color: $burnt-sienna-color;
  }

  &__main-text {
    color: var(--u-color-grey-900);

    &--with-bottom-margin {
      margin-bottom: 5px;
    }

    &--error {
      color: $concord-color;
      font-style: italic;
      text-align: center;
    }
  }

  &__additional-text {
    color: var(--u-color-grey-500);
  }

  &__close-button {
    align-self: flex-start;
    padding: 6px;
  }

  &__open-cart-button {
    font-weight: 600;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }
}

.close-button {
  &__icon {
    color: var(--u-color-grey-600);
    font-size: 15px;
    font-weight: 900;
  }
}

@media (min-width: 600px) {
  .notification {
    min-height: 64px;

    &__main-text {
      min-width: 260px;
    }

    &__open-cart-button {
      margin-right: 16px;
    }
  }
}

@media (min-width: 960px) {
  .notification {
    &__main-text {
      min-width: 300px;
    }
  }
}
</style>
